import can from 'can';

const visibilityChecker = new (can.Map.extend({
    define: {
        active: {
            type: 'boolean',
            value: true
        }
    }
}))();

// Set the name of the hidden property and the change event for visibility
let hiddenProperty, visibilityChange;
if (typeof document.hidden !== "undefined") { // Opera 12.10 and Firefox 18 and later support
    hiddenProperty = "hidden";
    visibilityChange = "visibilitychange";
} else if (typeof document.msHidden !== "undefined") {
    hiddenProperty = "msHidden";
    visibilityChange = "msvisibilitychange";
} else if (typeof document.webkitHidden !== "undefined") {
    hiddenProperty = "webkitHidden";
    visibilityChange = "webkitvisibilitychange";
}

if (typeof document.addEventListener === "undefined" || typeof document[hiddenProperty] === "undefined") {
    console.log("This functionality requires a browser, such as Google Chrome or Firefox, that supports the Page Visibility API.");
} else {
    // Handle page visibility change
    document.addEventListener(visibilityChange, () => visibilityChecker.attr('active', !document[hiddenProperty]), false);
}

export default visibilityChecker;